export const sliderData = [
    {
        image: "https://stmaaprodfwsite.blob.core.windows.net/assets/sites/1/2020/05/Felixstowe-containers-c-Shutterstock.jpg",
        heading: "RELIABLE CLEARING SERVICE" ,
        desc: "Neo Dynamics Limited is An Indigenous custom Clearing and Freight Forwarding service." ,
        button: "Get Started",
        
    },
    {
        image: "https://images.foxweather.com/static.foxweather.com/www.foxweather.com/content/uploads/2022/04/668/376/GettyImages-1346038906.jpg?ve=1&tl=1",
        heading: "WHY CONTACT US?" ,
        desc: "✅ Expertise in global trade practices, ✅ Extensive network of international partners, Etc." ,
        button: "Get Started",
    },
    {
        image: "https://cdn.motor1.com/images/mgl/GNqnx/s3/most-expensive-cars-lead.jpg",
        heading: "OUR TEAM IS READY" ,
        desc: "Contact Us Today to Start Your Export Journey!." ,
        button: "Get Started",
    },
    
];